import React, { Component } from 'react';
export default class LocationProducts extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      loadMore: false
    }
    this.toggleLoadMore = this.toggleLoadMore.bind(this);
  }

  toggleLoadMore() {
    const { loadMore } = this.state;
    this.setState({ loadMore: !loadMore });
  }

  filterContents() {
    const { contents } = this.props;
    const { loadMore } = this.state;
    let filteredContents = contents;
    if (!loadMore) {
      filteredContents = contents.slice(0, 9);
    }
    return filteredContents
  }

  getBackgroundImage(content) {
    const { placeholder_image } = this.props;
    if (content.images.length > 0) {
      return content.images[0]["image_large"];
    }
    return placeholder_image;
  }

  renderContents() {
    const filteredContents = this.filterContents();
    const renderedContents = filteredContents.map(content =>
      <div className="location-products-content col-xs-12 col-md-4" key={`content-id-${content.id}`}>
        <a href={content.link}>
          <div className="tile_4_3" style={{backgroundImage: `url(${this.getBackgroundImage(content)})`}}>
            <div className="image-fade-bottom" />
            <div className="overlay">
              <h2>{content.title}</h2>
            </div>
          </div>
        </a>
      </div>
    );
    return renderedContents;
  }

  renderLoadButton() {
    const { contents } = this.props;
    const { loadMore } = this.state;
    if (contents.length > 9) {
      return (
        <div className="col-xs-12" style={{textAlign: "center", marginBottom: "30px"}}>
          <div className="default-button" style={{cursor: "pointer"}} onClick={this.toggleLoadMore}>
            {loadMore ? "Show Less" : "Load More"}
          </div>
        </div>
      );
    }
    return <div className="col-xs-12" style={{marginBottom: "30px"}}></div>;
  }

  render() {
    const { contents } = this.props;
    if (contents.length > 0) {
      return (
        <div className="location-products">
          <div className="col-xs-12 location-products-title">
            At this branch
          </div>
          {this.renderContents()}
          {this.renderLoadButton()}
        </div>
      )
    }
    return <></>;
  }
}
